import * as React from "react";
import { Field, reduxForm, InjectedFormProps } from "redux-form";

import { TextInput } from "../../../components";
import validate from "../subscription-form-validation";

import "./SubscriptionForm.css";

export interface SubscriptionFormValues {
  source: string;
  email: string;
}

export interface SubscriptionFormProps {
  onClose: () => void;
}

export interface AugmentedSubscriptionFormProps
  extends InjectedFormProps<SubscriptionFormValues, SubscriptionFormProps>,
    SubscriptionFormProps {}

const SubscriptionForm = (props: AugmentedSubscriptionFormProps) => {
  return (
    <div className="subscription-box">
      <div className="subscription-box__container">
        <button type="button" className="close-btn" onClick={props.onClose}>
          <i className="fa fa-times" />
        </button>
        <form className="subscription-form" onSubmit={props.handleSubmit}>
          <p>Nhập email để nhận voucher giảm giá</p>
          <div className="subscription-form__container">
            <Field component="input" type="hidden" name="source" />
            <Field
              component={TextInput}
              className="form-group"
              type="email"
              name="email"
              placeholder="Email của bạn"
            />
            <Field
              component="input"
              className="form-group"
              type="hidden"
              name="campaign_token"
            />
            <button
              type="submit"
              className="btn submit-btn"
              disabled={props.submitting}
            >
              {props.submitting ? (
                <i className="fa fa-fw fa-pulse fa-spinner" />
              ) : (
                <i className="fa fa-fw fa-envelope" />
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default reduxForm<SubscriptionFormValues, SubscriptionFormProps>({
  form: "subscription",
  validate,
})(SubscriptionForm);



// WEBPACK FOOTER //
// ./src/routes/LandingPage/components/SubscriptionForm.tsx